export default "__VITE_ASSET__CH7efiEY__"